import { render } from "./PremiosCard.vue?vue&type=template&id=3d3bbf96"
import script from "./PremiosCard.vue?vue&type=script&lang=js"
export * from "./PremiosCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__